export class Freshpaint extends DrupalBehavior {
  onReady(document) {
    const clinicalAreasId = $('#clinical-area-div');
    if (clinicalAreasId.length > 0) {
      const clinicalAreasString = clinicalAreasId[0].dataset.clinicalAreas;
      if (clinicalAreasString && clinicalAreasString.length > 0) {
        freshpaint.addPageviewProperties({
          clinical_areas: clinicalAreasString,
        });
      }
    }
    freshpaint.track('RUSH Pageview');
  }
}

DrupalBehavior.register('rush_theme', 'freshpaint', Freshpaint);
